import { type RouteRecordRaw } from 'vue-router'

import { websiteBuilderModuleRouter } from '../builder/websiteBuilderModuleRouter'

export const websiteBuilderRouter: RouteRecordRaw[] = [
  ...websiteBuilderModuleRouter,
  {
    component: async () => import('../views/WebsiteBuilderPagesView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel.page'),
      condenseSidebar: true,
      title: 'website.pages',
    },
    name: 'brand.website.pages.home',
    path: 'pages',
  },
  {
    component: async () =>
      import('../views/WebsiteBuilderAnnouncementsView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel'),
      title: 'website.announcements',
    },
    name: 'brand.website.announcements',
    path: 'announcements',
  },
  {
    component: async () =>
      import('../views/WebsiteBuilderHestiaIframeView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'funnel.page'),
      condenseSidebar: true,
      hestiaPath: '/website/content',
      title: 'website.content',
    },
    name: 'brand.website.content',
    path: 'content',
  },
]
